import {FieldPath, FieldPathValue, FieldValues, useFormContext} from 'react-hook-form'

export const useFormValue = <TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>>(
  name: TFieldName,
  defaultValue?: FieldPathValue<TFieldValues, TFieldName>,
) => {
  const {watch} = useFormContext<TFieldValues>()
  return watch<TFieldName>(name, defaultValue)
}
